import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ChangeLog, Pagination, Response } from '@ui/src';
import { UserAccountProps, AccountLogs, Balance } from '../../types';
import { customersComponentApi } from '../../../customers/store/services/customers';

export interface CustomerAccountsState {
  logs?: AccountLogs[];
  accountsLogs?: ChangeLog[];
  accountsLogsPagination?: Pagination;
  closedBalances?: {
    id: string;
    value: number;
    currencyId: string;
  }[];
}

const initialState: CustomerAccountsState = {};

export const CustomerAccountsSlice = createSlice({
  name: 'customerAccounts',
  initialState,
  reducers: {
    clearAccountsState: (state) => {
      state.closedBalances = undefined;
    },

    clearSettingsPanel: (state) => {
      state.logs = undefined;
      state.accountsLogs = undefined;
      state.accountsLogsPagination = undefined;
      state.closedBalances = undefined;
    },
    clearClosingBalances: (state) => {
      state.closedBalances = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      customersComponentApi.endpoints.getCustomerAccountLogs.matchFulfilled,
      (state, action: PayloadAction<{ data: UserAccountProps }>) => {
        state.logs = action.payload.data.statusLogs;
      },
    );
    builder.addMatcher(
      customersComponentApi.endpoints.getCustomerAccountClosingBalances
        .matchFulfilled,
      (state, action: PayloadAction<{ data: Balance[] }>) => {
        state.closedBalances = action.payload.data;
      },
    );
    builder.addMatcher(
      customersComponentApi.endpoints.getCustomersAccountsChangeLogs
        .matchFulfilled,
      (
        state,
        action: PayloadAction<Response<ChangeLog>> & {
          meta: { arg: { originalArgs: string } };
        },
      ) => {
        if (!action.meta.arg.originalArgs.includes('cursor')) {
          state.accountsLogs = action.payload.data?.edges?.map(
            (item) => item.node,
          );
        } else {
          const nextChangeLogs = ([] as ChangeLog[]).concat(
            state.accountsLogs as ChangeLog[],
          );

          action.payload.data.edges?.forEach((item) => {
            nextChangeLogs.push(item.node);
          });

          state.accountsLogs = nextChangeLogs;
        }

        state.accountsLogsPagination = action.payload.data?.pageInfo;
      },
    );
  },
});

export const { clearAccountsState, clearSettingsPanel, clearClosingBalances } =
  CustomerAccountsSlice.actions;

export default CustomerAccountsSlice.reducer;
